<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Unidades</b>
            </h3>
            <router-link
              tag="a"
              class="btn btn-primary pull-right"
              to="/cadastros/unidades/novo"
              v-if="hasPermission('usuario.write')"
            >
              <span class="fa fa-plus"></span> Novo
            </router-link>
          </div>
          <div class="box-body">
            <form action @submit.prevent="getDataTable()">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label for>Unidade/CNPJ/CNES</label>
                    <input v-model="filtros.pesquisa" type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Categoria</label>
                    <select v-model="filtros.categoria" class="form-control">
                      <option value>Todas</option>
                      <option value="0">Pública (Local)</option>
                      <option value="1">Município Pactuado</option>
                      <option value="2">Privada</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group">
                    <label>Tipo de Unidade</label>
                    <select v-model="filtros.tipo_unidade_id" class="form-control">
                      <option value>Todas</option>
                      <option
                        v-for="item in tiposUnidade"
                        :key="item.id"
                        :value="item.id"
                      >{{ item.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group">
                    <label>Situação</label>
                    <select v-model="filtros.situacao" class="form-control">
                      <option value>Todas</option>
                      <option value="1">Ativo</option>
                      <option value="0">Inativo</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label class>&nbsp;</label>
                    <button class="btn btn-default btn-block">
                      <span class="fa fa-filter"></span> Filtrar
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%;">ID</th>
                      <th style="width: auto;">Unidade</th>
                      <th style="width: auto;">CNPJ</th>
                      <th style="width: auto;">CNES</th>
                      <th style="width: auto;">Categoria</th>
                      <th style="width: auto;">Situacao</th>
                      <th style="width: auto;">Tipo</th>
                      <th style="width: 10%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.nome }}</td>
                      <td>{{ item.cnpj }}</td>
                      <td>{{ item.cnes }}</td>
                      <td>{{ item.categoria | categoriaUnidade }}</td>
                      <td>{{ item.situacao | situacao }}</td>
                      <td>{{ item.tipo_unidade.nome }}</td>
                      <td>
                        <router-link
                          tag="button"
                          class="btn btn-success btn-sm"
                          :to="`/cadastros/unidades/editar/${item.id}`"
                          title="Editar Unidade"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-edit"></i>
                        </router-link>
                        <router-link
                          tag="button"
                          class="btn btn-warning btn-sm"
                          :to="'/cadastros/users/atualizacao/'+ item.id"
                          title="Profissionais da Unidade"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-users"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :limit="5"
                      :data="dataTable"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http

export default {
  filters: {},
  data: () => ({
    filtros: {
      pesquisa: "",
      categoria: "",
      situacao: "",
      tipo_unidade_id: "",
    },
    dataTable: {},
    tiposUnidade: []
  }),
  mounted() {
	this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
	this.filtros.categoria = this.$route.query.categoria ? this.$route.query.categoria : "";
	this.filtros.situacao = this.$route.query.situacao ? this.$route.query.situacao : "";
	this.filtros.tipo_unidade_id = this.$route.query.tipo_unidade_id ? this.$route.query.tipo_unidade_id : "";
    this.getTiposUnidade();
    this.getDataTable();
  },
  methods: {
    getTiposUnidade() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/cadastros/tipos-unidade/getAll`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.tiposUnidade = response.data;
        });
    },
    getDataTable(page) {
      if (typeof page === "undefined" || typeof page === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      axios
        .get(
          `${this.$store.state.serverURI}/api/cadastros/unidades/getAllPaginate`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    }
  },
  watch: {},
  components: {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?c57196ae